import { render, staticRenderFns } from "./Composers.vue?vue&type=template&id=e265e042&"
import script from "./Composers.vue?vue&type=script&lang=js&"
export * from "./Composers.vue?vue&type=script&lang=js&"
import style0 from "./Composers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/eric/projects/musical/musical-admin-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e265e042')) {
      api.createRecord('e265e042', component.options)
    } else {
      api.reload('e265e042', component.options)
    }
    module.hot.accept("./Composers.vue?vue&type=template&id=e265e042&", function () {
      api.rerender('e265e042', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Composers.vue"
export default component.exports